<script>
export default {
  name: 'LanguageSelector',
  data() {
    return {
      language: this.$locale,
      languages: ['de', 'en']
    }
  },
  methods: {
    changeLanguage() {
      this.$locale = this.language
      localStorage.setItem('lang', this.language)
    }
  },
  mounted() {
    this.$locale = localStorage.getItem('lang') || 'de'
    this.language = this.$locale
  }
}
</script>

<template>
  <select v-model="language" @change="changeLanguage">
    <option v-for="language in languages" :key="language" :value="language">
      {{ $t(`lang.${language}`) }}
    </option>
  </select>
</template>



// WEBPACK FOOTER //
// src/components/LanguageSelector.vue